<template>
  <v-navigation-drawer
    app
    :clipped="clipped"
    :fixed="fixed"
    :permanent="permanent"
    :mini-variant="mini"
    :mobile-break-point="drawer.mobileBreakPoint"
    :width="drawer.width"
    v-model="showDrawer"
  >

    <v-list
      expand
      dense
    >
      <v-list-tile
        to="/cv"
      >
        <v-list-tile-avatar>
          <v-icon>{{ itemHome.action }}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ itemHome.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>


      <v-list-group
        v-model="controls.active"
        :prepend-icon="controls.action"
        no-action
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{{ controls.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{ path: urlModel }" class="mt-3">
          <v-list-tile-content>
            <v-container>
              <v-layout align-center row justify-center fill-height>
                <v-flex xs12>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        block
                        color="yellow darken-3"
                        dark
                        v-on="on"
                      >
                        <v-icon dark left>description</v-icon>
                        <span>Choisir modèle</span>
                      </v-btn>
                    </template>
                    <span>Changer le modèle de cv</span>
                  </v-tooltip>

                </v-flex>
              </v-layout>
            </v-container>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-content>
            <v-container>
              <v-layout align-center row justify-center fill-height>
                <v-flex xs12>
                  <CvPreviewNew
                    :cvid="cvid"
                    :displayAsFab=false
                  >
                  </cvPreviewNew>
                </v-flex>
              </v-layout>
            </v-container>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="mb-3">
          <v-list-tile-content>
            <v-container>
              <v-layout align-center row justify-center fill-height>
                <v-flex xs12>
                  <CvDownloadPDF
                    :cvid="cvid"
                    :displayAsFab=false
                  >
                  </CvDownloadPDF>
                </v-flex>
              </v-layout>
            </v-container>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-list-group
        v-model="CustomOptions.active"
        :prepend-icon="CustomOptions.action"
        no-action
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{{ CustomOptions.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <ColorsSelector></ColorsSelector>
        <FontsSelector></FontsSelector>


      </v-list-group>


      <v-list-group
        v-model="itemsSection.active"
        :prepend-icon="itemsSection.action"
        no-action
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{{ itemsSection.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="subItem in itemsSection.items"
          :key="subItem.title"
          :to="{ path: urlcv, hash:subItem.link }"
        >
          <v-list-tile-content>
            <v-list-tile-title><v-icon class="mr-1">{{ subItem.icon }}</v-icon> {{ subItem.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
    </v-list>



  </v-navigation-drawer>
</template>

<script>

 /*
    Utilisation de <v-container> dans les v-list-tile des boutons.
    Sinon problème de centrage.
  */

 import { mapActions, mapState } from 'vuex';
 import CvPreviewNew from './CvPreviewNew.vue';
 import CvDownloadPDF from './CvDownloadPDF.vue';
 import ColorsSelector from './ColorsSelector';
 import FontsSelector from './FontsSelector.vue';

 export default {
   components: {
     CvPreviewNew,
     CvDownloadPDF,
     ColorsSelector,
     FontsSelector,
   },
   props: ['cvid'],
   data() {
     return {
       urlcv:'/cv/' + this.cvid + '/edit',
       urlModel: '/cv/' + this.cvid + '/cvmodels',
       drawer: {
         mobileBreakPoint: 960,
         width: 320,
       },
       itemHome: {
         action: 'home',
         title: 'Mes Curriculum Vitae',
       },
       itemsSection: {
         action: 'edit',
         title: 'Edition du CV',
         active: true,

         items: [
           { title: 'Infos Perso', icon:'face', link: "personal-infos" },
           { title: 'Profil', icon:'explore', link: "summary" },
           { title: 'Experiences PRO', icon:'business_center', link: "work-list" },
           { title: 'Formations', icon:'school', link: "edu-list" },
           { title: 'Compétences', icon:'build', link: "skill-list" },
           { title: 'Langues', icon:'language', link: "lang-list" },
           { title: 'Loisirs', icon:'wb_sunny', link: "hobby-list" },

         ]
       },
       controls: {
         action: 'apps',
         title: 'Controles',
         active: true,
       },
       CustomOptions: {
         action: 'settings',
         title: 'Options',
         active: true,
         items: [
           { title: 'Couleurs', icon:'color_lens' },
         ]
       },
     }
   },
   computed: {
     /*
        NOTE sur l'ouverture/fermeture de la sidebar en mode mobile (overlay) avec vuex.
        https://stackoverflow.com/questions/47442621/managing-state-for-overlay-dismissed-components-in-vuetify
        voir computed property showDrawer ci-dessous.
        Il faut un getter ET un Ajouter un setter afin de récupérer l'événement binder sur v-model.
      */
     showDrawer: {
       get() { return this.$store.state.sidebar.open },
       set(val) { this.$store.commit('sidebar/CLOSE_DRAWER', val) }
     },
     ...mapState('sidebar', [
       'open',
       'clipped',
       'fixed',
       'permanent',
       'mini',
     ]),
   },
   methods : {
     ...mapActions('sidebar', [
       'toggleDrawer',
       'closeDrawer',
     ]),
   }
 }
</script>
